module.exports = __webpack_public_path__ + "static/img/yongyaojilu2.ed0e9653.png";